import React from "react";
import { Helmet } from "react-helmet-async";
import "./About.css";
import AboutMission from "./AboutMission/AboutMission";

import img from "../../assets/about/sk-front.jpg";
import { FaGraduationCap } from "react-icons/fa";
import AboutJourney from "./AboutJourney/AboutJourney";

const AboutSkCollege = () => {
  return (
    <>
      <Helmet>
        <title>About SK College | History, Mission & Faculty</title>

        <meta
          name="description"
          content="Learn about SK College, founded in 2021 with a mission to provide quality higher education in rural areas. Meet our expert faculty and discover our academic vision."
        />

        <meta
          name="keywords"
          content="About SK College, SK College History, College Mission, Expert Faculty, Rural Education"
        />

        {/* Open Graph */}
        <meta
          property="og:title"
          content="About SK College | Official Website"
        />
        <meta
          property="og:description"
          content="Discover the journey, mission, and expert faculty of SK College committed to academic excellence."
        />
        <meta property="og:type" content="website" />
        <meta property="og:url" content="https://yourdomain.com/about" />
        <meta
          property="og:image"
          content="https://yourdomain.com/preview.jpg"
        />

        {/* Canonical */}
        <link rel="canonical" href="https://yourdomain.com/about" />
      </Helmet>

      <div className="about-sk-college-page">
        {/* ================= HERO SECTION ================= */}
        <section className="about-hero">
          <div className="hero-overlay"></div>
          
        </section>

        {/* ================= CONTENT WRAPPER ================= */}
        <div className="main-content-container">
          {/* ================= ABOUT SECTION ================= */}
          <section className="about-split-section">
            <div className="about-split-row">
              <div className="about-image-column">
                <div className="title-wrapper">
                  <h2 className="section-title-right">About SK College</h2>
                </div>
                <div className="image-wrapper">
                  <img src={img} alt="SK College Campus" />
                </div>
              </div>

              <div className="about-text-column">
                <div className="text-content">
                  <div className="title-wrapper">
                    <h2 className="section-title-right">About SK College</h2>
                  </div>
                  <div className="paragraphs-wrapper">
                    <div className="paragraph-item">
                      <p>
                        SK College was founded in{" "}
                        <span className="blue-highlight">2021</span> with a solemn
                        promise to bring world-class education to the rural
                        heartlands. We recognized that many{" "}
                        <span className="blue-highlight">talented students</span>,
                        especially the daughters of our village, were held back by the
                        distance to major cities like Jodhpur.
                      </p>
                    </div>
                    <div className="paragraph-item">
                      <p>
                        Our growth has been fueled by{" "}
                        <span className="blue-highlight">deep necessity</span>. From
                        our humble beginnings, we have expanded into a hub of
                        <span className="blue-highlight">
                          {" "}
                          academic excellence
                        </span>{" "}
                        and social change, ensuring that higher education is
                        accessible, inclusive, and empowering for every youth in our
                        community.
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>

          {/* ================= TEACHING METHODOLOGY ================= */}
          <section className="teaching-paragraph-section">
            <div className="teaching-content">
              <p>
                At SK College, our{" "}
                <span className="blue-highlight">teaching methodology</span> goes
                beyond traditional lectures. We believe in an{" "}
                <span className="blue-highlight">
                  interactive learning ecosystem
                </span>{" "}
                where students are encouraged to question, innovate, and
                collaborate. By integrating digital resources with hands-on
                practical sessions and dedicated{" "}
                <span className="blue-highlight">NCC training</span>, we instill a
                unique blend of academic intelligence and disciplined leadership
                in our students. Our goal is to bridge the gap between rural
                education and global standards through constant mentorship and
                value-based learning.
              </p>
            </div>
          </section>
        </div>

        <AboutMission />

        {/* ================= EXPERT FACULTY SECTION ================= */}
        <section className="faculty-section-modern">
          <div className="story-container">
            <h2 className="faculty-title">Our Expert Faculty</h2>

            <div className="faculty-grid-modern">
              {/* Faculty Card 1 */}
              <div className="faculty-card-modern">
                <div className="faculty-header">
                  <div className="faculty-icon-wrapper">
                    <FaGraduationCap className="faculty-icon" />
                  </div>
                  <h3 className="faculty-name">Laxman singh</h3>
                </div>
                <div className="faculty-post">Manager</div>
                <div className="faculty-experience">15+ Years Experience</div>
              </div>

              {/* Faculty Card 2 */}
              <div className="faculty-card-modern">
                <div className="faculty-header">
                  <div className="faculty-icon-wrapper">
                    <FaGraduationCap className="faculty-icon" />
                  </div>
                  <h3 className="faculty-name">Sneh Gupta</h3>
                </div>
                <div className="faculty-post">Executive Director</div>
                <div className="faculty-experience">15+ Years Experience</div>
              </div>

              {/* Faculty Card 3 */}
              <div className="faculty-card-modern">
                <div className="faculty-header">
                  <div className="faculty-icon-wrapper">
                    <FaGraduationCap className="faculty-icon" />
                  </div>
                  <h3 className="faculty-name">Bhairoon Singh Bhati</h3>
                </div>
                <div className="faculty-post">Secretary</div>
                <div className="faculty-experience">15+ Years Experience</div>
              </div>

              {/* Faculty Card 4 */}
              <div className="faculty-card-modern">
                <div className="faculty-header">
                  <div className="faculty-icon-wrapper">
                    <FaGraduationCap className="faculty-icon" />
                  </div>
                  <h3 className="faculty-name">Laxman Singh Ji</h3>
                </div>
                <div className="faculty-post">Physical Instructor</div>
                <div className="faculty-experience">15+ Years Experience</div>
              </div>
            </div>
          </div>
        </section>
        <AboutJourney />
      </div>
    </>
  );
};

export default AboutSkCollege;
